module.exports = __webpack_public_path__ + "static/media/cog-timer.4bfa0894.png";